import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useJesuisJecherche } from "../../../application/Context/JesuisJechercheContext";
export var InfoBar = function () {
    var count = useJesuisJecherche().count;
    var t = useTranslation(['jesuis-jecherche']).t;
    return (_jsx("div", { className: "under-filter-info", children: _jsxs("div", { children: [count, " ", t("éléments")] }) }));
};
